import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: JSON.parse(localStorage.getItem("userData")) || null,
  userallNotifications: [],
  totalunreads: 0,
  userallNotification: [],
  totalnotifications: 0,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getAllUserNotifications: (state, action) => {
      state.userallNotifications = action.payload.data;
      state.totalunreads = action.payload.total_unread;
    },
    addNewLiveNotification: (state, action) => {
      const newNotification = action.payload;
      const notificationExists = state.userallNotifications.some(
        (notif) => notif._id === newNotification._id
      );

      if (!notificationExists) {
        state.userallNotifications.unshift(newNotification);
        state.totalunreads += newNotification.read === false ? 1 : 0;
      }
    },
    setUnreadNotificationCount: (state, action) => {
      state.totalunreads = action.payload;
    },
    getUserAllNotifications: (state, action) => {
      state.userallNotification = action.payload.notifications;
      state.totalnotifications = action.payload.total;
    },
  },
});

export const {
  getAllUserNotifications,
  addNewLiveNotification,
  setUnreadNotificationCount,
  getUserAllNotifications,
} = notificationSlice.actions;
export default notificationSlice.reducer;

